import { i9FormIdFromPartnerSection2Token } from '@/features/section-2/application/validators/partner-section2-link';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Lands the partner's Section 2 deep link (`/sectiontwo?pt=<token>`) on the real Section 2 screen
 * (VTK-1918).
 *
 * The partner API mints that URL for the employer, but the app has no `/sectiontwo` route, so the
 * router's catch-all sent it to `/unauthorized` — a "403 Access Denied" that logging in could never
 * fix, because it was never an authorization failure. This translates the link into the route that
 * has existed all along.
 *
 * Deliberately a **redirect, not a second Section 2 implementation**: the destination keeps its own
 * `section2.update` guard, so this changes how the employer arrives, never what they may do. The
 * token names the form; the session authorizes it.
 *
 * An unreadable or non-Section-2 token falls through to `/unauthorized`, exactly as today.
 */
export default function PartnerSection2Redirect() {
  const [searchParams] = useSearchParams();
  const i9FormId = i9FormIdFromPartnerSection2Token(searchParams.get('pt'));

  if (!i9FormId) return <Navigate to="/unauthorized" replace />;

  // `replace`, so the bearer token is not left in history behind a Back press.
  return <Navigate to={`/section-2/${i9FormId}`} replace />;
}
